import type { SessionStepModule } from '../types';
import { RationCardDetail } from './RationCardDetail';
import { RationCardStepRunner } from './RationCardStepRunner';
import { isRationStep } from './ration.utils';

// Ration Card Verification step module (Protean ration-card lookup).
export const rationStepModule: SessionStepModule = {
  key: 'ration',
  matches: isRationStep,
  Runner: RationCardStepRunner,
  Detail: RationCardDetail,
};
